export default __webpack_public_path__ + "static/media/left-icon.5e10c1b2.svg";